import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "pokemon-details" }
const _hoisted_2 = {
  key: 1,
  class: "pokemon-details__header"
}
const _hoisted_3 = { class: "page-title" }
const _hoisted_4 = { class: "pokemon-details__genus" }
const _hoisted_5 = {
  key: 2,
  class: "pokemon-details__details"
}
const _hoisted_6 = { class: "pokemon-details__sprite-container" }
const _hoisted_7 = { class: "pokemon-details__sprite-background" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "pokemon-details__data" }
const _hoisted_10 = {
  key: 5,
  class: "pokemon-details__moves"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", { class: "pokemon-details__title underline-border" }, "Moves", -1)
const _hoisted_12 = { class: "pokemon-details__moves-table-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_PokedexData = _resolveComponent("PokedexData")!
  const _component_Breeding = _resolveComponent("Breeding")!
  const _component_Stats = _resolveComponent("Stats")!
  const _component_EvolutionLine = _resolveComponent("EvolutionLine")!
  const _component_MovesTable = _resolveComponent("MovesTable")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_loader, {
          key: 0,
          "pokemon-name": _ctx.tmpPkmnName
        }, null, 8, ["pokemon-name"]))
      : _createCommentVNode("", true),
    (_ctx.pokemon && !_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("header", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.pokemon.name), 1),
          _createElementVNode("small", _hoisted_4, _toDisplayString(_ctx.genus), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.pokemon && !_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("img", {
                class: "pokemon-details__sprite",
                src: _ctx.pokemonArtworkUrl,
                alt: _ctx.pokemon.name + 'sprite'
              }, null, 8, _hoisted_8)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_PokedexData, { pokemon: _ctx.pokemon }, null, 8, ["pokemon"]),
            _createVNode(_component_Breeding, { pokemon: _ctx.pokemon }, null, 8, ["pokemon"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.pokemon && !_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_Stats, {
          key: 3,
          stats: _ctx.pokemon.stats
        }, null, 8, ["stats"]))
      : _createCommentVNode("", true),
    (_ctx.pokemon && !_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_EvolutionLine, {
          key: 4,
          species: _ctx.species
        }, null, 8, ["species"]))
      : _createCommentVNode("", true),
    (_ctx.pokemon && !_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("section", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            (
            _ctx.moves.filter(
              (move) =>
                move.version_group_details[0].move_learn_method.name ===
                'level-up'
            ).length > 0
          )
              ? (_openBlock(), _createBlock(_component_MovesTable, {
                  key: 0,
                  moves: 
            _ctx.moves.filter(
              (move) =>
                move.version_group_details[0].move_learn_method.name ===
                'level-up'
            )
          ,
                  "table-lable": "Learnt by Level Up",
                  variant: "level-up"
                }, null, 8, ["moves"]))
              : _createCommentVNode("", true),
            (
            _ctx.moves.filter(
              (move) =>
                move.version_group_details[0].move_learn_method.name === 'egg'
            ).length > 0
          )
              ? (_openBlock(), _createBlock(_component_MovesTable, {
                  key: 1,
                  moves: 
            _ctx.moves.filter(
              (move) =>
                move.version_group_details[0].move_learn_method.name === 'egg'
            )
          ,
                  "table-lable": "Egg Moves"
                }, null, 8, ["moves"]))
              : _createCommentVNode("", true),
            (
            _ctx.moves.filter(
              (move) =>
                move.version_group_details[0].move_learn_method.name === 'tutor'
            ).length > 0
          )
              ? (_openBlock(), _createBlock(_component_MovesTable, {
                  key: 2,
                  moves: 
            _ctx.moves.filter(
              (move) =>
                move.version_group_details[0].move_learn_method.name === 'tutor'
            )
          ,
                  "table-lable": "Learnt by Tutor"
                }, null, 8, ["moves"]))
              : _createCommentVNode("", true),
            (
            _ctx.moves.filter(
              (move) =>
                move.version_group_details[0].move_learn_method.name ===
                'machine'
            ).length > 0
          )
              ? (_openBlock(), _createBlock(_component_MovesTable, {
                  key: 3,
                  moves: 
            _ctx.moves.filter(
              (move) =>
                move.version_group_details[0].move_learn_method.name ===
                'machine'
            )
          ,
                  "table-lable": "Learnt by TM",
                  variant: "tm"
                }, null, 8, ["moves"]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}